/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AiChatbotRequest } from "../models/index";
import {
    AiChatbotRequestFromJSON,
    AiChatbotRequestToJSON,
} from "../models/index";

export interface AiChatbotQueryStreamRequest {
    body?: AiChatbotRequest;
}

/**
 *
 */
export class AiChatbotStreamHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Submit a question to the Azure AI Foundry chatbot agent and stream back the AI response as it\'s generated.
     */
    async aiChatbotQueryStreamRaw(
        requestParameters: AiChatbotQueryStreamRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/ai-chatbot/query-stream`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: AiChatbotRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get("content-type"))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Submit a question to the Azure AI Foundry chatbot agent and stream back the AI response as it\'s generated.
     */
    async aiChatbotQueryStream(
        requestParameters: AiChatbotQueryStreamRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<string> {
        const response = await this.aiChatbotQueryStreamRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
